// Global Swiper instances
let productShowcaseThumbnails = null;
let productShowcaseMainSlider = null;

// Function to initialize/reinitialize Swiper instances
function initProductShowcaseSwipers() {
  const thumbnailsContainer = document.querySelector(".product-showcase__thumbnails");
  const mainSliderContainer = document.querySelector(".product-showcase__main-slider");
  
  if (!thumbnailsContainer || !mainSliderContainer) return;
  
  const thumbnailSlides = thumbnailsContainer.querySelectorAll('.swiper-slide').length;
  
  // Destroy existing instances if they exist
  if (productShowcaseThumbnails && typeof productShowcaseThumbnails.destroy === 'function') {
    productShowcaseThumbnails.destroy(true, true);
  }
  if (productShowcaseMainSlider && typeof productShowcaseMainSlider.destroy === 'function') {
    productShowcaseMainSlider.destroy(true, true);
  }
  
  // Initialize thumbnails slider with same config as initial load
  productShowcaseThumbnails = new Swiper(".product-showcase__thumbnails", {
    spaceBetween: 4.5,
    slidesPerView: 5,
    watchSlidesProgress: true,
    breakpoints: {
      990: {
        direction: "vertical",
        spaceBetween: 10,
        slidesPerView: 4.8536,
      },
    }
  });
  
  // Add centering class if needed
  const swiperWrapper = thumbnailsContainer.querySelector('.swiper-wrapper');
  if (swiperWrapper && thumbnailSlides < 5) {
    swiperWrapper.classList.add('swiper-wrapper--centered');
  } else if (swiperWrapper) {
    swiperWrapper.classList.remove('swiper-wrapper--centered');
  }
  
  // Initialize main slider with same config as initial load
  productShowcaseMainSlider = new Swiper(".product-showcase__main-slider", {
    spaceBetween: 10,
    loop: true,
    thumbs: {
      swiper: productShowcaseThumbnails,
    },
  });
}

// Initialize on load
initProductShowcaseSwipers();

// Expose function globally for product-selector.js
window.initProductShowcaseSwipers = initProductShowcaseSwipers;

// Re-apply centering on resize
window.addEventListener('resize', function() {
  const thumbnailsContainer = document.querySelector(".product-showcase__thumbnails");
  const swiperWrapper = thumbnailsContainer ? thumbnailsContainer.querySelector('.swiper-wrapper') : null;
  const thumbnailSlides = thumbnailsContainer ? thumbnailsContainer.querySelectorAll('.swiper-slide').length : 0;
  
  if (swiperWrapper && thumbnailSlides < 5) {
    swiperWrapper.classList.add('swiper-wrapper--centered');
  } else if (swiperWrapper) {
    swiperWrapper.classList.remove('swiper-wrapper--centered');
  }
});

// Ingredients dropdown functionality
(() => {
  const ingredientsContainers = document.querySelectorAll('.product-showcase__ingredients');
  if (!ingredientsContainers.length) return;
  
  ingredientsContainers.forEach(container => {
    const toggle = container.querySelector('[data-ingredients-toggle]');
    const content = container.querySelector('[data-ingredients-content]');
    
    if (!toggle || !content) return;
    
    // Initialize content as closed
    content.style.maxHeight = '0px';
    
    toggle.addEventListener('click', () => {
      const isOpen = container.classList.toggle('is-open');
      if (isOpen) {
        content.style.maxHeight = (content.scrollHeight + 400) + 'px';
      } else {
        content.style.maxHeight = '0px';
      }
    });
  });

  // Nutrition modal functionality
  const nutritionButtons = document.querySelectorAll('[data-nutrition-modal]');
  const modal = document.querySelector('[data-modal]');
  const modalBackdrop = document.querySelector('[data-modal-backdrop]');
  const modalClose = document.querySelector('[data-modal-close]');
  const modalContainer = document.querySelector('.nutrition-modal__container');
  
  if (nutritionButtons.length && modal) {
    // Open modal
    nutritionButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      });
    });
    
    // Close modal functions
    const closeModal = () => {
      modal.classList.remove('is-open');
      document.body.style.overflow = ''; // Restore scrolling
    };
    
    // Close on backdrop click (clicking outside the container)
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target === modalBackdrop) {
        closeModal();
      }
    });
    
    // Prevent closing when clicking inside the container
    if (modalContainer) {
      modalContainer.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
    
    // Close on close button click
    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }
    
    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }
})();

// Quantity selector functionality
(() => {
  const quantityContainers = document.querySelectorAll('.product-showcase__quantity');
  
  quantityContainers.forEach(container => {
    const input = container.querySelector('[data-quantity-input]');
    const display = container.querySelector('[data-quantity-display]');
    const minusBtn = container.querySelector('.product-showcase__quantity-minus');
    const plusBtn = container.querySelector('.product-showcase__quantity-plus');
    
    if (!input || !display || !minusBtn || !plusBtn) return;
    
    const updateDisplay = () => {
      display.textContent = input.value;
    };
    
    minusBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value);
      if (currentValue > 1) {
        input.value = currentValue - 1;
        updateDisplay();
      }
    });
    
    plusBtn.addEventListener('click', () => {
      const currentValue = parseInt(input.value);
      input.value = currentValue + 1;
      updateDisplay();
    });
    
    input.addEventListener('change', updateDisplay);
  });
})();

// Variant selector functionality
class ProductShowcase extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.form = document.querySelector(`#product-form-${this.closest('section').id.replace('section--', '')}`);
    this.variantIdInput = this.form?.querySelector('input[name="id"]');
    this.priceElement = document.querySelector('[data-product-price]');
    this.addToCartButton = document.querySelector('[data-add-to-cart]');
    this.variantTitleElement = document.querySelector('[data-variant-title]');
    this.variantImageTitleElement = document.querySelector('[data-variant-image-title]');
    this.variantDescriptionElement = document.querySelector('.product-showcase__description-desktop');
    this.variantDescriptionMobileElement = document.querySelector('.product-showcase__description-mobile');
    
    this.initVariantSelectors();
    this.initAddToCart();
    //this.initSelectedVariant();
  }
  
  initAddToCart() {
    if (!this.form) return;
    
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      if (this.addToCartButton) {
        this.addToCartButton.disabled = true;
        
        try {
          const formData = new FormData(this.form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (response.ok) {
            const data = await response.json();
            
            document.dispatchEvent(new CustomEvent('cart:item-added', { 
              detail: data 
            }));
            
            this.addToCartButton.disabled = false;
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          this.addToCartButton.disabled = false;
        }
      }
    });
  }
  
  initVariantSelectors() {
    const variantContainers = document.querySelectorAll('.product-showcase__variants[data-option-index]');
    
    variantContainers.forEach(container => {
      const buttons = container.querySelectorAll('[data-variant-option]');
      const valueDisplay = container.querySelector('[data-selected-value]');
      
      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Update active state
          buttons.forEach(btn => btn.closest('.product-showcase__variant').classList.remove('product-showcase__variant--active'));
          button.closest('.product-showcase__variant').classList.add('product-showcase__variant--active');
          
          // Update display value
          if (valueDisplay) {
            valueDisplay.textContent = button.dataset.optionValue.toLowerCase();
          }
          
          // Update variant
          this.updateVariant();
        });
      });
    });
  }
  
  updateVariant() {
    const selectedOptions = this.getSelectedOptions();
    const variant = this.getVariantFromOptions(selectedOptions);
    
    if (variant) {
      this.updateVariantId(variant.id);
      this.updatePrice(variant.price);
      this.updateUrl(variant.id);
      this.updateGalleryImage(variant);
      this.updateVariantTitle(variant);
      this.updateVariantImageTitle(variant);
      this.updateVariantDescription(variant);
      this.updateAddToCartButton(variant);
    }
  }
  
  updateGalleryImage(variant) {
    if (variant.featured_image && productShowcaseMainSlider) {
      // Find the index of the variant image in the main slider
      const slides = document.querySelectorAll('.product-showcase__main-img img');
      let targetIndex = 0;
      
      slides.forEach((img, index) => {
        if (img.src.includes(variant.featured_image.split('?')[0].split('/').pop().split('.')[0])) {
          targetIndex = index;
        }
      });
      
      productShowcaseMainSlider.slideTo(targetIndex);
    }
  }
  
  getSelectedOptions() {
    const options = [];
    const variantContainers = document.querySelectorAll('.product-showcase__variants[data-option-index]');
    
    variantContainers.forEach(container => {
      const activeButton = container.querySelector('.product-showcase__variant--active [data-variant-option]');
      if (activeButton) {
        options.push(activeButton.dataset.optionValue);
      }
    });
    
    return options;
  }
  
  getVariantFromOptions(options) {
    // This would need product data from Shopify
    // For now, we'll use a data attribute approach
    const productData = window.productData || {};
    const variants = productData.variants || [];
    
    return variants.find(variant => {
      return options.every((option, index) => {
        return variant[`option${index + 1}`] === option;
      });
    });
  }
  
  updateVariantId(variantId) {
    if (this.variantIdInput) {
      this.variantIdInput.value = variantId;
    }
  }
  
  updatePrice(price) {
    if (this.priceElement) {
      // Format price (this is a simple version, you might want to use Shopify's money format)
      const formattedPrice = `$${(price / 100).toFixed(2)}`;
      this.priceElement.textContent = formattedPrice;
    }
  }
  
  updateUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }
  
  updateVariantTitle(variant) {
    /*
    if (this.variantTitleElement && variant.title) {
      this.variantTitleElement.textContent = variant.title;
    }
    */
  }
  
  updateVariantImageTitle(variant) {
    if (this.variantImageTitleElement) {
      const imgElement = this.variantImageTitleElement.querySelector('img');
      if (imgElement) {
        if (variant.label_tag_icon) {
          imgElement.style.display = 'block';
          imgElement.src = variant.label_tag_icon;
          imgElement.alt = variant.title || '';
        } else {
          // Hide the image if there's no label_tag_icon
          imgElement.style.display = 'none';
        }
      }
    }
  }

  updateVariantDescription(variant) {
    if (variant.description) {
      if (this.variantDescriptionElement) {
        this.variantDescriptionElement.innerHTML = variant.description;
      }
      if (this.variantDescriptionMobileElement) {
        this.variantDescriptionMobileElement.innerHTML = variant.description;
      }
    }
  }

  updateAddToCartButton(variant) {
    if (!this.addToCartButton) return;
    
    const buttonTextElement = this.addToCartButton;
    const isAvailable = variant.available;
    
    if (isAvailable) {
      // Variante disponible
      buttonTextElement.disabled = false;
      buttonTextElement.classList.remove('disabled', 'is-out-of-stock');
      buttonTextElement.removeAttribute('aria-disabled');
      buttonTextElement.style.backgroundColor = '';
      buttonTextElement.style.borderColor = '';
      buttonTextElement.style.color = '';
      buttonTextElement.style.cursor = '';
      
      // Obtener el texto original del botón desde el data attribute o usar default
      const originalText = buttonTextElement.dataset.originalText || 'ADD TO CART';
      buttonTextElement.textContent = originalText;
    } else {
      // Variante sin stock
      buttonTextElement.disabled = true;
      buttonTextElement.classList.add('disabled', 'is-out-of-stock');
      buttonTextElement.setAttribute('aria-disabled', 'true');
      buttonTextElement.style.backgroundColor = '#E0E0E0';
      buttonTextElement.style.borderColor = '#D5D5D5';
      buttonTextElement.style.color = '#666';
      buttonTextElement.style.cursor = 'not-allowed';
      buttonTextElement.textContent = 'SOLD OUT';
    }
  }
  
  initSelectedVariant() {
    console.log('initSelectedVariant')
    const productData = window.productData || {};
    const selectedVariantId = productData.selected_variant_id;
    
    if (selectedVariantId && productData.variants) {
      const selectedVariant = productData.variants.find(v => v.id === selectedVariantId);
      if (selectedVariant) {

        this.updateVariantId(selectedVariant);
        this.updatePrice(selectedVariant);
        this.updateUrl(selectedVariant);
        this.updateGalleryImage(selectedVariant);
        this.updateVariantTitle(selectedVariant);
        this.updateVariantImageTitle(selectedVariant);
        this.updateVariantDescription(selectedVariant);
      }
    }
  }
}

customElements.define('product-showcase', ProductShowcase);